<template>
  <loading
    :active="loading"
    :can-cancel="true"
    :on-cancel="onCancel"
    :is-full-page="fullPage"
    :color="`#efe406`"
    :background-color="`#ab0525`"
    :opacity="1"
    :loader="'dots'"
    :lock-scroll="true"
  />
</template>
<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
export default {
  name: 'LoadingState',
  components: {
    Loading,
  },
  props: ['loading', 'onCancel'],
  data() {
    return {
      useSlot: true,
      fullPage: true,
      spinner: 'spinner',
    };
  },
};
</script>
